import { createSelector } from '@reduxjs/toolkit';
import { EPriceType } from '../../../../packages/JsonQuery';
import { selectIsSquareMeterPrice } from 'shared/selectors/jsonQuery';

export const selectPriceTypeValue = createSelector(selectIsSquareMeterPrice, isSquareMeterPrice =>
  isSquareMeterPrice ? EPriceType.SM : EPriceType.Total,
);
